"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionBlock = void 0;
var Block_1 = require("modules/Block");
var Initializer_1 = require("modules/Initializer");
require("./accordion-block.scss");
var AccordionBlock = (function (_super) {
    __extends(AccordionBlock, _super);
    function AccordionBlock() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.allAccordions = null;
        _this.handleAccordionClick = function (e) {
            var _a, _b;
            var clickedAccordion = e.currentTarget;
            if (!(clickedAccordion instanceof Element))
                return;
            var isActive = clickedAccordion === null || clickedAccordion === void 0 ? void 0 : clickedAccordion.classList.contains("active");
            (_a = _this.allAccordions) === null || _a === void 0 ? void 0 : _a.forEach(function (accordion) {
                var _a;
                accordion.classList.remove("active");
                (_a = accordion.nextElementSibling) === null || _a === void 0 ? void 0 : _a.setAttribute("aria-expanded", "false");
            });
            if (!isActive) {
                clickedAccordion.classList.add("active");
                (_b = clickedAccordion.nextElementSibling) === null || _b === void 0 ? void 0 : _b.setAttribute("aria-expanded", "true");
            }
        };
        return _this;
    }
    AccordionBlock.prototype.init = function () {
        var _this = this;
        this.allAccordions = this.rootElement.querySelectorAll(".js-accordion-expand");
        this.allAccordions.forEach(function (accordion) {
            accordion.addEventListener("click", _this.handleAccordionClick);
        });
    };
    return AccordionBlock;
}(Block_1.Block));
exports.AccordionBlock = AccordionBlock;
Initializer_1.Initializer.initBlock(".js-accordion-block", AccordionBlock);
